<template>
  <div>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn small icon v-bind="attrs" v-on="on">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="confirmDeleteLesson">
          <v-list-item-title>Xóa buổi học</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'DeleteLesson',
  props: {
    lesson: {
      type: Object,
      required: true,
    },
  },
  methods: {
    ...mapActions('lesson', ['deleteLesson']),
    async confirmDeleteLesson() {
      const isConfirmed = confirm('Khi xóa dữ liệu buổi học sẽ xóa các dữ liệu liên quan đến điểm danh và đánh giá. Bạn có chắc chắn muốn xóa chúng không?')
      if (isConfirmed) {
        try {
          await this.deleteLesson(this.lesson.id)
          this.$emit('delete', this.lesson.id)
          this.$alert.success('Xóa buổi học thành công')
        } catch (error) {
          this.$alert.error(error)
        }
      }
    },
  },
}
</script>
